import { DEV_ENV } from "./dev";
import { STAGING_ENV } from "./staging";
import { PROD_ENV } from "./prod";

var environment = process.env.NODE_ENV;

var envConfig = null;

if (environment === "development") {
  envConfig = DEV_ENV;
}

if (environment === "staging") {
  envConfig = STAGING_ENV;
}

if (environment === "production") {
  envConfig = PROD_ENV;
}

export { envConfig };



// WEBPACK FOOTER //
// ./src/config/config.js